import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatDate = (dateObject?: string | number | Date | dayjs.Dayjs | null) =>
  dayjs(dateObject).format('YYYY-MM-DD');

export const getSystemRegistrationTime  = () => dayjs().format();